/**
 * @generated SignedSource<<e1d07984b577db48b7ecdd332628cb11>>
 * @relayHash 9db18599ae8276f38e57885f4b3ed842
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID edafd438720a1dc9f3ad7178421078636892a9a16b7d545d094272279358a150

import type { ConcreteRequest } from 'relay-runtime';
export type SpaceOverviewIdQuery$variables = {
  spaceKey?: string | null;
};
export type SpaceOverviewIdQuery$data = {
  readonly space: {
    readonly homepageId: string | null;
    readonly id: string | null;
  } | null;
};
export type SpaceOverviewIdQuery = {
  response: SpaceOverviewIdQuery$data;
  variables: SpaceOverviewIdQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "spaceKey"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "key",
        "variableName": "spaceKey"
      }
    ],
    "concreteType": "Space",
    "kind": "LinkedField",
    "name": "space",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "id"
      },
      {
        "kind": "ScalarField",
        "name": "homepageId"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "SpaceOverviewIdQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SpaceOverviewIdQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "9db18599ae8276f38e57885f4b3ed842",
    "id": "edafd438720a1dc9f3ad7178421078636892a9a16b7d545d094272279358a150",
    "metadata": {},
    "name": "SpaceOverviewIdQuery",
    "operationKind": "query",
    "text": "query SpaceOverviewIdQuery($spaceKey:String){space(key:$spaceKey){id,homepageId}}"
  }
};
})();

(node as any).hash = "7fd7786f0088a31ebf4c6fb6bedcf998";

export default node;
